import React from "react";
import {IconButton, Snackbar, SnackbarCloseReason} from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import {useTheme} from "../../../contexts/theme";

interface StyledBarProps {
    open: boolean;
    setClose: () => void;
    message: string;
    severity: string;
    closeButton: boolean;
}

const StyledSnackBar: React.FC<StyledBarProps> = ({open, message, setClose, severity, closeButton}) => {
    const theme = useTheme();
    const handleClose = (
        event: React.SyntheticEvent | Event,
        reason?: SnackbarCloseReason,
    ) => {
        if (reason === 'clickaway') {
            return;
        }
        setClose();
    };

    const action = (
        <React.Fragment>
            <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={handleClose}
            >
                <CloseIcon fontSize="small" />
            </IconButton>
        </React.Fragment>
    );

    return (
        <Snackbar
            anchorOrigin={theme.snackbarPosition}
            open={open}
            message={message}
            onClose={handleClose}
            action={closeButton ? action : undefined}
        />
    );
};

export default StyledSnackBar;